import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">热点专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">全网最热爆料 · 深度追踪报道</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {carouselData.map((item) => (
            <article key={item.id} className="bg-background-50 rounded-lg border border-background-200 overflow-hidden flex flex-col group cursor-pointer hover:border-primary-200 transition-colors">
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-1 rounded text-[10px] font-semibold bg-primary-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4 flex flex-col gap-2 flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.summary}</p>
                <div className="flex items-center justify-between mt-auto pt-2 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-accent-500"></i>
                    {item.heat}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}